import { IconFont } from "@/components/IconFont"
import Dialog from "@/libs/dialog"
import { Button } from "antd"
import { useEffect, useState } from "react"
import styles from './styles.module.less'
import { OperationsTable } from "./OperationsTable"
import { useRequest } from "ahooks"
import { getSetOps } from "@/services/project/simulation.service"
import { useSelector } from "react-redux"
import { getFlowSimulationSelector, getTopologyState } from "@/store/flowsheet/flowsheet.slice"

interface SetOperationsProps {
  className?: string
  onChange: () => void
}

export const SetOperations = (props: SetOperationsProps) => {
  const {className, onChange} = props;
  const [visible, setVisible] = useState(false)
  const sim = useSelector(getFlowSimulationSelector)
  const {data, run} = useRequest(() => getSetOps({sId: sim?.id}), {manual: true})
  const topologyState = useSelector(getTopologyState)


  useEffect(() => {
    if (sim && visible) {
      run()
    }
  }, [sim, visible, topologyState])

  return <div className={className}>
    <Button icon={<IconFont type="icon-s1" />} onClick={() => setVisible(true)} />
    {visible && <Dialog onClose={() => setVisible(false)} width={1000} title="Set Operations" visible={true} footer={null}>
      <div className={styles.body}>
        <OperationsTable onChange={onChange} data={data} />
      </div>
    </Dialog>}
  </div>
}